export default "__VITE_ASSET__D_YXqf5W__"